import { styled } from '@linaria/react';

export const Container = styled.div``;

export const Text = styled.span`
	font-size: 18px;
	line-height: 32px;
	font-weight: 500;
	white-space: nowrap;
`;
